module.exports = __webpack_public_path__ + "img/DemonHunter-nightelf-f-110.035f8055.gif";